// extracted by mini-css-extract-plugin
module.exports = {"VideoPlayerWrapper":"VideoPlayer_VideoPlayerWrapper__5AsCn","VideoPlayer":"VideoPlayer_VideoPlayer__gZHV_"};